import { render, staticRenderFns } from "./SentimentTrend.vue?vue&type=template&id=5338e68a&"
import script from "./SentimentTrend.vue?vue&type=script&lang=ts&"
export * from "./SentimentTrend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports